module.exports = __webpack_public_path__ + "static/media/vu.ecffcb5b.svg";